/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCountryState
 */
export interface MelcoModelsCountryState {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCountryState
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCountryState
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCountryState
     */
    country_code?: string | null;
}

export function MelcoModelsCountryStateFromJSON(json: any): MelcoModelsCountryState {
    return MelcoModelsCountryStateFromJSONTyped(json, false);
}

export function MelcoModelsCountryStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCountryState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
    };
}

export function MelcoModelsCountryStateToJSON(value?: MelcoModelsCountryState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'country_code': value.country_code,
    };
}


